import {info} from "services-comun/modules/browser/log";

import { Auth } from "../../../../services/auth";
import { IConfig } from "../../../../config";
import { Ruta, IRuta } from "../../../ruta";

export class RedaccionNoticiasEdit extends Ruta {
    /* STATIC */
    public static build(config: IConfig, id: number): RedaccionNoticiasEdit {
        return new this({
            id,
            ruta: `${config.router.basePath}/redaccion/noticias/edit/`,
        });
    }

    /* INSTANCE */
    public constructor(data: IRuta) {
        super(data);
    }

    public async check(path: string): Promise<void> {
        if (!path.startsWith(this.data.ruta)) {
            return Promise.reject("Redaccion/Noticias/Edit: Rechazada");
        }
        let resto = path.substr(this.data.ruta.length).match(/[1-9][\d]*/);
        if (resto==null) {
            return Promise.reject("Redaccion/Noticias/Edit: Rechazada");
        }
    }

    public async load(auth: Auth, config: IConfig, state?: any): Promise<void> {
        require("panel-templates/css/general.scss");

        info("Cargando NavBar");
        const {NavBar} = await import(/* webpackChunkName: "navbar" */ `../../../../componentes/navbar`);
        await NavBar.load(auth, config, state);
        info("Cargando Redaccion/Noticias/Edit");
        const {RedaccionNoticiasEdit} = await import(/* webpackChunkName: "redaccion-noticias-edit" */ `../../../../componentes/redaccion/noticias/editar/edit`);
        await RedaccionNoticiasEdit.load(auth, config, state);
    }

    public async unload(): Promise<void> {
        // info("Descargando NavBar");
        // const {NavBar} = await import(/* webpackChunkName: "navbar" */ `../../../../componentes/navbar`);
        // await NavBar.unload();
        info("Descargando Redaccion/Noticias/Edit");
        const {RedaccionNoticiasEdit} = await import(/* webpackChunkName: "redaccion-noticias-edit" */ `../../../../componentes/redaccion/noticias/editar/edit`);
        await RedaccionNoticiasEdit.unload();
    }

    public async updateEstado(state?: any): Promise<void> {
        info("Actualizando el estado de NavBar");
        const {NavBar} = await import(/* webpackChunkName: "navbar" */ `../../../../componentes/navbar`);
        await NavBar.updateEstado(state);
        info("Actualizando el estado de Redaccion/Noticias/Edit");
        const {RedaccionNoticiasEdit} = await import(/* webpackChunkName: "redaccion-noticias-edit" */ `../../../../componentes/redaccion/noticias/editar/edit`);
        await RedaccionNoticiasEdit.updateEstado(state);
    }
}
